(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setButtonState = (track, previous, next) => {
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    if (previous) previous.disabled = atStart && track.dataset.infinite !== 'true';
    if (next) next.disabled = atEnd && track.dataset.infinite !== 'true';
  };

  const initImageSlider = track => {
    if (track.dataset.magneoScrollSliderReady === 'true') return;
    track.dataset.magneoScrollSliderReady = 'true';

    const slider = track.closest('.image-slider');
    const slides = Array.from(track.children);
    const previous = slider?.querySelector('.slider-arrow-prev');
    const next = slider?.querySelector('.slider-arrow-next');
    const dots = slider?.querySelector('.magneo-scroll-slider__dots');
    const infinite = track.dataset.infinite === 'true';
    const smooth = !reduceMotion.matches;
    let autoPlayTimer;

    const activeIndex = () => {
      const left = track.scrollLeft;
      return slides.reduce((best, slide, index) => (
        Math.abs(slide.offsetLeft - left) < Math.abs(slides[best].offsetLeft - left) ? index : best
      ), 0);
    };

    const goTo = index => {
      if (!slides.length) return;
      const target = slides[(index + slides.length) % slides.length];
      track.scrollTo({ left: target.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };

    const step = direction => {
      if (!slides.length) return;
      const index = activeIndex();
      const requested = index + direction;
      if (requested < 0 && infinite) return goTo(slides.length - 1);
      if (requested >= slides.length && infinite) return goTo(0);
      goTo(Math.max(0, Math.min(slides.length - 1, requested)));
    };

    const dotButtons = dots ? slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'magneo-scroll-slider__dot';
      button.setAttribute('aria-label', `Go to slide ${index + 1}`);
      button.addEventListener('click', () => goTo(index));
      dots.appendChild(button);
      return button;
    }) : [];

    const refresh = () => {
      const index = activeIndex();
      dotButtons.forEach((button, dotIndex) => button.setAttribute('aria-current', String(dotIndex === index)));
      setButtonState(track, previous, next);
    };

    previous?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(refresh), { passive: true });
    window.addEventListener('resize', refresh, { passive: true });

    if (track.dataset.autoplay === 'true' && !reduceMotion.matches) {
      const delay = Number(track.dataset.autoplayDelay) || 5000;
      const stop = () => window.clearInterval(autoPlayTimer);
      const start = () => {
        stop();
        autoPlayTimer = window.setInterval(() => step(1), delay);
      };
      track.addEventListener('pointerenter', stop);
      track.addEventListener('focusin', stop);
      track.addEventListener('pointerleave', start);
      track.addEventListener('focusout', start);
      start();
    }

    refresh();
  };

  const initLogoList = list => {
    if (list.dataset.magneoLogoScrollReady === 'true') return;
    list.dataset.magneoLogoScrollReady = 'true';
    const start = () => {
      if (window.innerWidth >= 750 || list.dataset.autoplay !== 'true' || reduceMotion.matches) return;
      const delay = Number(list.dataset.autoplayDelay) || 5000;
      window.setInterval(() => {
        const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
        list.scrollTo({ left: atEnd ? 0 : list.scrollLeft + list.clientWidth, behavior: 'smooth' });
      }, delay);
    };
    start();
  };

  const init = () => {
    document.querySelectorAll('[data-magneo-scroll-slider]').forEach(initImageSlider);
    document.querySelectorAll('[data-magneo-logo-scroll]').forEach(initLogoList);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
